// extracted by mini-css-extract-plugin
export default {"achievementsCard":"SpecialistAchievementsCard_achievementsCard__8HA0w"};